import { memo } from 'react';

import MuiRadio, { RadioProps } from '@material-ui/core/Radio';

import clsx from 'clsx';
import { useStyles } from './style';

const Radio: React.FC<RadioProps> = (props) => {
  const classes = useStyles();

  return (
    <MuiRadio
      classes={{ root: classes.zeroPadding }}
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
};

export default memo(Radio);
